import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import SEO from '../components/SEO';

const MaintenancePage = () => {
  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 py-16"
      style={{
        background:
          'linear-gradient(180deg, #fbf7ef 0%, #ffffff 50%, #fbf3f1 100%)',
        fontFamily: "'Outfit', sans-serif",
      }}
      data-testid="maintenance-page"
    >
      <SEO
        title="Wartungsmodus"
        description="FaceinPlace Kosmetikstudio – wir gestalten unsere Website neu. Termine weiterhin telefonisch oder per E-Mail."
        path="/"
        noIndex
      />

      <div className="max-w-2xl mx-auto text-center">
        {/* Logo */}
        <div className="flex items-center justify-center gap-4 mb-12">
          <img
            src="/faceinplace-monogram.png"
            alt="FaceinPlace Monogramm"
            className="h-16 md:h-20 w-auto"
            data-testid="maintenance-logo"
          />
          <div
            className="text-3xl md:text-4xl tracking-[0.18em] text-stone-900"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 600 }}
          >
            FACE <em className="italic font-light text-rose-500">in</em> PLACE
          </div>
        </div>

        {/* Gold divider */}
        <div className="flex items-center justify-center gap-4 mb-10">
          <span className="h-px w-12 bg-gradient-to-r from-transparent to-[#c9a875]/70" />
          <span
            className="text-[#c9a875] text-xs uppercase tracking-[0.42em]"
            style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 600 }}
          >
            Wir gestalten neu
          </span>
          <span className="h-px w-12 bg-gradient-to-r from-[#c9a875]/70 to-transparent" />
        </div>

        {/* Headline */}
        <h1
          className="text-4xl md:text-5xl lg:text-6xl font-light text-stone-900 mb-6 leading-[1.1]"
          style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300 }}
        >
          Wir gestalten unsere Website{' '}
          <em className="italic text-rose-500">für Sie neu!</em>
        </h1>

        {/* Subtext */}
        <p
          className="text-lg md:text-xl text-stone-600 max-w-xl mx-auto mb-14 leading-relaxed"
          style={{ fontWeight: 300 }}
        >
          FaceinPlace ist bald mit neuen Angeboten und Online-Buchung für Sie da.
        </p>

        {/* Contact card */}
        <div className="bg-white/80 backdrop-blur-sm border border-rose-100 rounded-2xl shadow-[0_30px_60px_-30px_rgba(244,63,94,0.25)] p-8 md:p-10 max-w-xl mx-auto">
          <p
            className="text-stone-700 mb-6 text-base md:text-lg"
            style={{ fontWeight: 300 }}
          >
            Bei Terminwünschen erreichen Sie uns weiterhin unter:
          </p>

          <div className="space-y-4">
            <a
              href="tel:+4915141650404"
              className="group flex items-center justify-center gap-3 text-stone-900 hover:text-rose-500 transition-colors"
              data-testid="maintenance-phone"
            >
              <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-rose-50 group-hover:bg-rose-500 group-hover:text-white transition-all">
                <Phone className="w-4 h-4" />
              </span>
              <span
                className="text-lg md:text-xl tracking-wide"
                style={{ fontWeight: 500 }}
              >
                +49 151 41650404
              </span>
            </a>

            <a
              href="mailto:info@faceinplace.de"
              className="group flex items-center justify-center gap-3 text-stone-900 hover:text-rose-500 transition-colors"
              data-testid="maintenance-email"
            >
              <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-rose-50 group-hover:bg-rose-500 group-hover:text-white transition-all">
                <Mail className="w-4 h-4" />
              </span>
              <span
                className="text-lg md:text-xl tracking-wide"
                style={{ fontWeight: 500 }}
              >
                info@faceinplace.de
              </span>
            </a>
          </div>

          <div className="mt-8 pt-6 border-t border-rose-100">
            <div className="flex items-center justify-center gap-2 text-stone-500 text-sm">
              <MapPin className="w-4 h-4" />
              <span>Zentgasse 3 · 97453 Schonungen</span>
            </div>
          </div>
        </div>

        {/* Footer mini */}
        <p className="text-stone-400 text-xs mt-12 tracking-wider uppercase">
          FaceinPlace Kosmetikstudio · Maria Mangold
        </p>
      </div>
    </div>
  );
};

export default MaintenancePage;
